import { render, staticRenderFns } from "./BoxPerformanceComparisonRadar.vue?vue&type=template&id=064bdc97&scoped=true&"
import script from "./BoxPerformanceComparisonRadar.vue?vue&type=script&lang=js&"
export * from "./BoxPerformanceComparisonRadar.vue?vue&type=script&lang=js&"
import style0 from "./BoxPerformanceComparisonRadar.vue?vue&type=style&index=0&id=064bdc97&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064bdc97",
  null
  
)

export default component.exports
import {QCard,QTable} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QTable})
